// NOTE: Please keep these in sync with src/client/commons/styles/_config.scss
const cssVariableNames = [
  "product-tile-height",
  "product-tile-height-s",
  "product-tile-height-no-brand",
  "product-tile-height-s-no-brand",
  "slider-tile-width",
  "slider-tile-width-l",
  "countdown-size"
] as const;

type CSSVariableName = (typeof cssVariableNames)[number];

function getVar(varName: CSSVariableName): string {
  const prefixedName = `--${varName}`;
  return getComputedStyle(document.documentElement).getPropertyValue(prefixedName).trim();
}

export default function useCssVars() {
  return Object.fromEntries(cssVariableNames.map(name => [name, getVar(name)])) as Record<
    CSSVariableName,
    ReturnType<typeof getVar>
  >;
}
